import { render, staticRenderFns } from "./CompetenceTypeView.vue?vue&type=template&id=6740b65e&scoped=true"
import script from "./CompetenceTypeView.vue?vue&type=script&lang=js"
export * from "./CompetenceTypeView.vue?vue&type=script&lang=js"
import style0 from "./CompetenceTypeView.vue?vue&type=style&index=0&id=6740b65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740b65e",
  null
  
)

export default component.exports